import {
  Document,
  Page,
  Text,
  View,
  Font,
  StyleSheet,
} from "@react-pdf/renderer";
import Amiri from "../assets/fonts/Amiri/Amiri-Regular.ttf";

// Register font
Font.register({
  family: "Amiri",
  src: Amiri,
});

const styles = StyleSheet.create({
  page: {
    fontFamily: "Amiri",
    padding: 40,
    direction: "rtl",
    backgroundColor: "#F7FAF7",
  },

  card: {
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    padding: 24,
  },

  header: {
    textAlign: "center",
    marginBottom: 20,
  },

  title: {
    fontSize: 22,
    fontWeight: "bold",
    color: "#1B5E20",
  },

  subtitle: {
    fontSize: 12,
    marginTop: 4,
    color: "#4A5568",
  },

  divider: {
    height: 1,
    backgroundColor: "#E2E8F0",
    marginVertical: 16,
  },

  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },

  label: {
    fontSize: 11,
    color: "#718096",
  },

  value: {
    fontSize: 12,
    color: "#1A202C",
  },

  amountBox: {
    backgroundColor: "#E8F5E9",
    padding: 12,
    borderRadius: 6,
    marginVertical: 16,
    textAlign: "center",
  },

  amount: {
    fontSize: 20,
    color: "#2E7D32",
    fontWeight: "bold",
  },

  sectionTitle: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#2E7D32",
    marginBottom: 8,
  },

  listItem: {
    fontSize: 12,
    marginBottom: 6,
  },

  footer: {
    marginTop: 30,
    textAlign: "center",
    fontSize: 10,
    color: "#718096",
  },
});

const Row = ({ label, value }) => (
  <View style={styles.row}>
    <Text style={styles.label}>{label}</Text>
    <Text style={styles.value}>{value}</Text>
  </View>
);

export const ReceiptPdf = ({ donation }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.card}>
        {/* Header */}
        <View style={styles.header}>
          <Text style={styles.title}>إيصال تبرع</Text>
          <Text style={styles.subtitle}>جمعية أراكان الإنسانية</Text>
        </View>

        <View style={styles.divider} />

        {/* Info */}
        <Row label="رقم الطلب" value={donation.OrderId} />
        <Row label="اسم المتبرع" value={donation.user} />
        <Row label="البريد الإلكتروني" value={donation.email} />
        <Row label="تاريخ الدفع" value={donation.TransactionDate} />

        {/* Amount */}
        <View style={styles.amountBox}>
          <Text style={styles.amount}>
            {donation.PurchAmount} {donation.original_currency}
          </Text>
        </View>

        {/* Items */}
        <Text style={styles.sectionTitle}>تفاصيل التبرع</Text>
        {donation.donation_items.map((item, i) => (
          <Text key={i} style={styles.listItem}>
            • {item.project}
          </Text>
        ))}

        {/* Footer */}
        <View style={styles.footer}>
          <Text>شكراً لثقتكم ودعمكم المستمر</Text>
          <Text>www.arakanha.online</Text>
        </View>
      </View>
    </Page>
  </Document>
);
